/**
 * TierBadge — the accessible quality indicator for an option's tier.
 *
 * Conveys tier through THREE redundant channels (never colour alone, WCAG 1.4.1): a Lucide icon,
 * a text label, and colour. Used on option tiles and in the feedback reveal.
 */
import { Check, CheckCheck, TriangleAlert, X, type LucideIcon } from "lucide-react";
import { TIER_META, type OptionTier } from "@patc/content-schema";
import { TIER_STYLE, cx } from "../lib/ui";

const ICONS: Record<string, LucideIcon> = {
  "check-check": CheckCheck,
  check: Check,
  "alert-triangle": TriangleAlert,
  x: X,
};

export function TierBadge({ tier, className }: { tier: OptionTier; className?: string }) {
  const meta = TIER_META[tier];
  const Icon = ICONS[meta.icon] ?? Check;
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-sm font-semibold",
        TIER_STYLE[tier].text,
        className,
      )}
    >
      <Icon size={16} strokeWidth={2} aria-hidden="true" />
      <span>{meta.label}</span>
    </span>
  );
}
